import React, { Component } from 'react';
import { translate } from 'react-i18next';
import swal from 'sweetalert';
import MaskedFormControl from 'react-bootstrap-maskedinput';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';

var Config = require('../../config');
const genders = ["HOMBRE","MUJER"];

class DonorData extends Component{

    constructor(props, context) {
		super(props, context);

        this.setJobProfile = this.setJobProfile.bind(this);

        this.state = {
            documents:[],
            civil_status_array:[],
            scholarships:[],
            jobProfiles:[]
		};
	}

    componentDidMount(){
        this.props.onRef(this);

		fetch(Config.default.apiGateway.URL+'lookups?type=document_type&notrender=0',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      documents: response
		    });
		})

        fetch(Config.default.apiGateway.URL+'lookups?type=CIVIL_STATUS&option=actives&order=false',{ 
		    method: 'get',
		    headers: new Headers({
		       	'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       	'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
		  	this.setState({
		      civil_status_array: response
		    });
		})

        //llamada a servicio de escolaridad
		fetch(Config.default.apiGateway.URL+'lookups?type=SCHOOLING&option=actives&order=false',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      scholarships: response
		    });
		})

        //llamada a servicio de ocupacion
		fetch(Config.default.apiGateway.URL+'lookups?type=profession&option=actives&order=false',{ 
		    method: 'get',
		    headers: new Headers({
		       	'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       	'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
		  	this.setState({
		      jobProfiles: response
		    });
		})	
    }

    componentWillUnmount() {
		this.props.onRef(null)
	}

    setJobProfile(profile){

    	for (var i = 0; i < this.state.jobProfiles.length; i++) {
				
			if (this.state.jobProfiles[i].key === profile) {
				this.setState({
					indice:i,
					requestedSelected: [this.state.jobProfiles[i]],
				});
				break;
			}
		}	
    }

    handleTypeAheadChange = name => values => {
        if(values.length > 0){
        	this.setState({
				indice:0,
				requestedSelected:values,
		    });
        	this.props.autocompleteHandle(name,values[0].key);
        	
        }else if(this.state.requestedSelected.length > 0){
        	this.setState({
        		requestedSelected:[]
        	});
        }
	}

    render(){
        const { t } = this.props;
        return(
            <div className="col-xs-12" style={{padding:"0px"}}>
                {this.props.showField("donor", "document_type")?
                    <div className="col-xs-12 col-sm-2" >
                        <span className="span-min">{t('content.offers.form.document_type')}</span>
                            
                        <select className="form-control" onKeyPress={(e) => this.props.validate(e)}
                            name="document_type" id="document_type" 
                            value={ this.props.state.document_type || ""} 
                            onChange={ this.props.selectFieldHandle.bind(null,"id","document_type") }
                            > 
                            <option value="" disabled>Seleccionar...</option>
                            {
                                this.state.documents.map(function(t) {
                                return <option key={t.id}  value={t.key} >{t.name} </option>;
                                })
                            }
                        </select>
                    </div>
                :null}
                {this.props.showField("donor", "document_number")?
                    <div className="col-xs-12 col-sm-2" >
                        <span className="span-min">{t('content.offers.form.number')}</span>
                        <input className="form-control" 
                            name="document_number" id="document_number" value={ this.props.state.document_number || "" } 
                            onChange={ this.props.handleChange } onKeyPress={(e) => this.props.validate(e)} />
                    </div>
                :null}
                {this.props.showField("donor", "gender")?
                    <div className="col-xs-12 col-sm-2" >
                        <span className="span-min">{t('content.offers.form.gender')}</span>
                        <select className="form-control" id="sex" name="sex" value={ this.props.state.sex } 
                            onChange={ this.props.selectFieldHandle.bind(null,"id","sex") } onKeyPress={(e) => this.props.validate(e)}> 
                            <option value="" disabled>Seleccionar...</option>
                            {
                                genders.map(function(t) {
                                    return <option key={t}  value={t} >{t} </option>;
                                })
                            }
                        </select>
                    </div>
				:null}	

                {this.props.showField("donor", "civil_status")?
                    <div className=" col-xs-12 col-sm-2" >
                        <span className="span-min">{t('content.offers.form.civil_status')}</span>
                        <select className="form-control" 
                            name="civil_status" id="civil_status" value={ this.props.state.civil_status } 
                            onChange={ this.props.selectFieldHandle.bind(null,"id","civil_status") }
                            onKeyPress={(e) => this.props.validate(e)}
                            > 
                            <option value="" disabled>Seleccionar...</option>
                            {
                                this.state.civil_status_array.map(function(t) {

                                    return <option key={t.id}  value={t.key} >{t.name} </option>;
                                })
                            }
                        </select>
                    </div>
                :null}

                {this.props.showField("donor", "birthday")?
                    <div className="form-group col-xs-12 col-sm-2" style={{marginBottom: 0}}>
                        <span className="span-min">{t('content.offers.form.birthday')}</span>
                        <MaskedFormControl type='text' name="birthday" id="birthday" 
                                value={this.props.state.birthday} 
                                onChange={this.props.dateHandleChange} onKeyPress={(e) => this.props.validate(e)}
                                mask='11/11/1111' placeholder="dd/mm/yyyy" className="form-control input-date" />
                    </div>
                :null}

                {this.props.showField("donor", "age")?
                    <div className="form-group col-xs-12 col-sm-1" style={{paddingRight: 0,marginBottom: 0}}>
                        <span className="span-min">{t('content.offers.form.age')}</span>
                        <input className="form-control" name="age" value={ this.props.state.age } 
                            onChange={ this.props.handleChange } onKeyPress={(e) => this.props.validate(e)} disabled/>
                    </div>
                :null}
						
                <div className=" col-xs-12 col-sm-4" >
                    <span className="span-min">{t('content.offers.form.names')}</span>
                    <input className="form-control" id="names" name="names"
                        value={ this.props.state.names } onKeyPress={(e) => this.props.validate(e)} 
                        onChange={ this.props.handleChange } required/>
                </div>

                <div className="col-xs-12 col-sm-2">
                    <span className="span-min">{t('content.offers.form.lastname1')}</span>
                    <input id="lastname1" className="form-control" name="lastname1" 
                        value={ this.props.state.lastname1} onChange={ this.props.handleChange }
                        onKeyPress={(e) => this.props.validate(e)} required/>
                </div>

                {this.props.showField("donor", "lastname2")?
                    <div className="col-xs-12 col-sm-2" >
                        <span className="span-min">{t('content.offers.form.lastname2')}</span>
                        <input className="form-control" name="lastname2" id="lastname2" value={ this.props.state.lastname2 } 
                            onChange={ this.props.handleChange } 
                            onKeyPress={(e) => this.props.validate(e)}/>
                    </div>
                :null}

                {this.props.showField("donor", "email")?
                    <div className="col-xs-12 col-sm-4" >
                        <span className="span-min">{t('content.offers.form.email')} </span>
                        <span className="span-min" style={{color:'red'}}>{this.props.state.error_email}</span>
                        <input className="form-control" id="email" name="email" 
                            placeholder="nombre@example.com"
                            value={ this.props.state.email || ""} onChange={ this.props.handleChange } 
                            onKeyPress={(e) => this.props.validate(e)}/>
                    </div>
                :null}

                {this.props.showField("donor", "scholarship")?
                    <div className="col-xs-12 col-sm-2" >
                        <span className="span-min">{t('content.offers.form.scholarship')} </span>
                        <select className="form-control" name="scholarship" id="scholarship"
                            value={ this.props.state.scholarship ||""} 
                            onChange={ this.props.selectFieldHandle.bind(null,"id","scholarship") } 
                            onKeyPress={(e) => this.props.validate(e)} >
                            <option value="" disabled>Seleccionar...</option>
                            {
                                this.state.scholarships.map(function(t) {
                                    return <option  key={t.id}  value={t.key} >{t.name}</option>;
                                })
                            }
                        </select>
                    </div>
                :null}

                {this.props.showField("donor", "job_profile")?
                    <div className="col-xs-12 col-sm-4" >
                        <span className="span-min">{t('content.offers.form.job_profile')}</span>
                        <AsyncTypeahead 
                                /*{...this.state}*/
                                labelKey={(option) => `${option.name}`}
                                minLength={0}
                                id="job_profile" name="job_profile"
                                onKeyPress={(e) => this.props.validate(e)}
                                options={this.state.jobProfiles}
                                onChange={this.handleTypeAheadChange('job_profile')}
                                onSearch={this._handleSearchJob}
                                defaultSelected={this.state.jobProfiles.slice(this.state.indice, 1)}
                                selected={this.state.requestedSelected}
                                ref="_handleSearch_job"
                                useCache={false}	
                                isLoading={this.state.isLoading}
                                delay={600}
                                paginationText="Mostrar mas resultados..."
                        />
                    </div>
                :null}
            </div>
        );
    }
}

export default translate('translations')(DonorData);